import { render, staticRenderFns } from "./Aquarius.vue?vue&type=template&id=419e022a"
import script from "./Aquarius.vue?vue&type=script&lang=js"
export * from "./Aquarius.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports